'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './ballot-result.routes';

export class BallotResultComponent {
  constructor(Auth, VotingsService, dialogs, $uibModal, $stateParams, $window, User, SettingsService, VoterGroupsService, ClosingSnapshotsService) {
    'ngInject';

    this.VotingsService = VotingsService;
    this.VoterGroupsService = VoterGroupsService;
    this.ClosingSnapshotsService = ClosingSnapshotsService;
    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.id;

    this.back = _ => $window.history.back();

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    this.chartData = [];
    this.chartLabel = [];


    this.totalWeightMultiplier = 1;
    this.responseMap = {};
    this.weightedResponseMap = {};
    this.totalResponses = 0;
    this.totalOnline = 0;
    this.totalPaper = 0;
    this.totalBlank = 0;

    this.writeInResponses = [];

    let processData = _ => {

      this.ballot = this.vote.ballots.find(ballot => ballot._id == this.ballotId);

      this.ballot.responses.forEach(r => this.responseMap[r] = 0);
      this.ballot.responses.forEach(r => this.weightedResponseMap[r] = 0);

      this.users.forEach(property => {

        if (!this.isContactVoting) {
          let weight = property.eVoting.weight || 1;
          this.totalWeightMultiplier += (weight - 1);
        }

        let ballotVote = this.vote.votes.find(v =>
          v.ballot == this.ballotId
          && (
          (this.vote.voterGroup.type == 'properties' && v.property == property._id)
          || this.vote.voterGroup.type ==  'contacts' && v.voter == property._id) // proprety is here the contact //TODO: rename all to make more sense
        );

        if (ballotVote) {

          this.totalResponses++;

          if (ballotVote.type == 'evote')
            this.totalOnline++;
          else if (ballotVote.type == 'paper')
            this.totalPaper++;

          if (!this.ballot.secret) {

            if (!ballotVote.responses || !ballotVote.responses.length) {
              this.totalBlank++;
            } else {
              ballotVote.responses.forEach(r => {
                if (this.ballot.responses.indexOf(r) === -1 && this.writeInResponses.indexOf(r) === -1) {
                  this.writeInResponses.push(r);
                  this.responseMap[r] = 0;
                  this.weightedResponseMap[r] = 0;
                }

                let weight = ballotVote.weight || 1;

                this.responseMap[r]++;
                this.weightedResponseMap[r] += weight;
              });
            }

          }

        }
      });

      if (this.ballot.secret) {

        let addSecretVoteToResult = secretVote => {
          if (!secretVote.vote || !secretVote.vote.length) {
            this.totalBlank++;
            return;
          }

          secretVote.vote.forEach(r => {

            if (this.ballot.responses.indexOf(r) === -1 && this.writeInResponses.indexOf(r) === -1) {
              this.writeInResponses.push(r);
              this.responseMap[r] = 0;
              this.weightedResponseMap[r] = 0;
            }

            let weight = secretVote.weight || 1;

            this.responseMap[r]++;
            this.weightedResponseMap[r] += weight
          })
        };

        this.secureLoading = true;

        this.VotingsService.getVotesByBallot({
          id: this.vote._id,
          ballotId: this.ballotId
        }, data => {

          if (this.ballot.rules.maxResponses === 1) {
            for (let i = 0; i<this.totalResponses; i++) {
              addSecretVoteToResult(data[i]);
            }
          } else {
            data.forEach(secretVote => addSecretVoteToResult(secretVote));
          }

          this.ballot.responses.forEach(response => {
            this.chartLabel.push(response);
            this.chartData.push(this.responseMap[response]);
          });

          this.writeInResponses.forEach(response => {
            this.chartLabel.push(response);
            this.chartData.push(this.responseMap[response]);
          });

          this.secureLoading = false;
          this.ready = true;
        }, err => console.log(err));

      } else {
        this.ready = true;
      }

      if (!this.ballot.secret) {
        this.ballot.responses.forEach(response => {
          this.chartLabel.push(response);
          this.chartData.push(this.responseMap[response]);
        });

        this.writeInResponses.forEach(response => {
          this.chartLabel.push(response);
          this.chartData.push(this.responseMap[response]);
        });
      }

    };

    SettingsService.getByName({name: 'client'}, settings => {
      this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
      this.weightVisible = settings.data.weightVisible;
      this.useSuite = settings.data.useSuite;

        this.VotingsService.get({id: this.voteId}, (vote) => {
          this.vote = vote;

          if (this.vote.state == 'closed' && this.vote.closingSnapshot) {
            this.ClosingSnapshotsService.get({id: this.vote.closingSnapshot}, snapshot => {
              this.snapshotDate = snapshot.meta.clientDate || snapshot.meta.creationDate;
              this.snapshot = snapshot;

              this.isContactVoting = this.snapshot && this.snapshot.type == 'contacts';
              this.users = snapshot.data;

              this.vote.voterGroup = snapshot;
              if (this.isContactVoting)
                this.vote.voterGroup.contacts = snapshot.data;
              else
                this.vote.voterGroup.properties = snapshot.data;

              processData();
            });
          } else {
            let VG_QUERY_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
            this.VoterGroupsService[VG_QUERY_METHOD]({id: this.vote.voterGroup._id}, vg => {
              this.isContactVoting = this.vote.voterGroup && this.vote.voterGroup.type == 'contacts';
              this.users = (this.isContactVoting) ? vg.contacts : vg.properties;
              processData();
            });
          }
      });

    });

  }

}

export default angular.module('conduu.ballotResult', [uiRouter])
  .config(routes)
  .component('ballotResult', {
    template: require('./ballot-result.html'),
    controller: BallotResultComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/ballot/ballot-result/ballot-result.component.js